import React from 'react';
import DefaultBoundary from './views/DefaultBoundary.view';
import QuoteError from './views/QuoteErrorBoundary.view';
import UserOffline from './views/UserOffline.view';
import NetworkError from './views/NetworkError.view';
import ChunkFailed from './views/ChunkFailed.view';

export function renderViewBasedOnError(error) {
  const errorViewMap = {
    QuoteError,
    UserOffline,
    NetworkError,
    ChunkFailed,
  };

  const { name } = error;
  const View = errorViewMap[name] || DefaultBoundary;

  return <View />;
}
